import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, media, radii, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleWrapper = styled.div`
  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

export const Lead = styled.div`
  margin-top: ${space['spacing-xl']};

  p {
    margin: 0;
  }

  @media (${media.desktop}) {
    margin-top: 3.125rem;
  }
`

/* Duas colunas preenchidas linha a linha, como no desenho. As linhas de cada
   coluna dividem uma borda, então o gap entre colunas é o que as separa. */
export const List = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0 ${space['spacing-md']};
  margin-top: ${space['spacing-xl']};

  @media (${media.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (${media.desktop}) {
    margin-top: 3.125rem;
  }
`

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['spacing-md']};
  padding: ${space['spacing-md']} ${space['spacing-lg']};
  background-color: ${colors['neutral-background-default']};

  p {
    margin: 0;
  }

  /* O bloco de cada coluna se comporta como um cartão único: só a primeira
     e a última linha arredondam, e as internas dividem a borda. */
  &:not(:last-child) {
    border-bottom: 1px solid ${colors['neutral-border-weak']};
  }

  &:first-child {
    border-top-left-radius: ${radii['corner-radius-sm']};
    border-top-right-radius: ${radii['corner-radius-sm']};
  }

  &:last-child {
    border-bottom-left-radius: ${radii['corner-radius-sm']};
    border-bottom-right-radius: ${radii['corner-radius-sm']};
  }
`

export const Download = styled.a`
  flex: 0 0 auto;
  color: ${colors['blue-text-default']};
  font-weight: ${theme.fontWeights['font-weight-medium']};
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`
